import type { CreateOptions, UnavailableReason } from '@cims-online/shared'
import type { DisabledOptions } from 'hooks/useDisabledOptions'
import { parseDisabled } from 'utils/parseDisabled'

const messages: Record<UnavailableReason, string> = {
  disabled: 'Record creation is disabled',
  invalid_configuration: 'The record creation configuration is invalid',
  invalid_field: 'A configured creation field is unavailable',
  missing_status: 'A configured creation status is unavailable',
  no_target_statuses: 'No creation target statuses are configured',
  unsupported_configuration:
    'The record creation configuration is not supported',
}

export function createDisabledOptions(
  createOptions: Pick<CreateOptions, 'targetStatuses' | 'unavailableReason'>
): DisabledOptions | undefined {
  const { targetStatuses, unavailableReason } = createOptions
  const hasAvailableTargetStatus = targetStatuses.some(
    ({ enabled, valid }) => enabled && valid
  )

  if (unavailableReason === null && !hasAvailableTargetStatus)
    return {
      disabled: true,
      reason: {
        why: 'disabled',
        message: 'No target statuses are available for record creation',
      },
    }
  if (unavailableReason === null) return undefined
  return {
    disabled: true,
    reason: { why: 'disabled', message: messages[unavailableReason] },
  }
}

export function createTableActionDisabled(
  options: DisabledOptions | undefined
): false | { message: string } {
  const message = parseDisabled(options)
  return message ? { message } : false
}
